module.exports = __webpack_public_path__ + "static/media/6a93fd2c-54c0-4612-a52f-ac47e4f708dc_1.a0c3cefb92cdd282aa0a8f8f66016f1e.0c2b2c54.jpeg";